import { unbusyAll } from '../actions/commonActions';
import commonHandler, { ResponseOrError } from './common-handler';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import AttributeCRUDActions from '../actions/AttributeCRUDActions';
import { getErrorJson } from '@mm/utils';
import { showDeleteErrorModal } from '../actions/viewActions';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';

export default (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action?: string) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      if (action === AttributeCRUDActions.deleteAction) {
        const parsed = await getErrorJson(error);
        dispatch(showDeleteErrorModal(parsed && parsed.errors));
      }
      dispatch(unbusyAll());
    } else {
      commonHandler(dispatch)(error);
    }
  };
